// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__2kRZC","loader":"Loader_loader__32Bst"};